import { Component, HostListener, OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from 'src/app/entities/service';
import { ServiceService } from 'src/app/services/service.service';
import { AuthService } from 'src/app/services/auth.service';
import { NavigationStart, NavigationEnd, Event as NavigationEvent, Router } from '@angular/router';
import { SharedService } from 'src/app/services/sharedService';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ProcessService } from 'src/app/services/process.service';
import {AdminService} from "../../services/admin.service";
import { hasStoredSession } from '../../util/session.util';
import { languages, SUPPORTED_LANGUAGES } from '../../util/app-config';
import { HelpCard, DEFAULT_HELP_CARDS, mergeHelpCards, textFor } from '../help/help-cards';
import { CARDS_KEY } from '../help/help.component';

@Component({
    selector: 'app-fusion-nav-header',
    templateUrl: './header.component.html',
    styleUrls: ['../shared/styles/nav-header.css', './header.component.css'],
    standalone: false
})

export class HeaderComponent implements OnInit, OnDestroy {
  leftMenuItems = [];
  leftMenuSubscription: any;
  @Input() contextMenu: string[];
  lang: string;
  username: string;
  initials: string;
  menuItems: string[][];
  lanList;
  user;
  services: Service[];
  dropDownNotifications: any[];
  unseenNotifications = 0;
  loginSubscription: any;
  isAssigned = false
  controlsModuleEnabled = false

  /**
   * The help cards, for the side menu on /help.
   *
   * Starts as the shipped catalogue so the menu is complete before the
   * settings request comes back -- and stays complete if it never does.
   */
  private helpCards: HelpCard[] = DEFAULT_HELP_CARDS;
  mobileMenuOpen = false;
  servicesExpanded = false;
  adminExpanded = false;
  sidenavOpen = false;
  currentUrl: string = '';

  get isServicesRoute(): boolean {
    return this.getMenuKeyFromUrl(this.currentUrl) === 'services';
  }

  get isAdminRoute(): boolean {
    return this.getMenuKeyFromUrl(this.currentUrl) === 'admin';
  }
  constructor(public translate: TranslateService, public serviceService: ServiceService,
              public userService: UserService, public notificationService: NotificationService,
              public auth: AuthService, public router: Router, public sharedService: SharedService,
              public processService: ProcessService,
              private settings: AdminService) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setFallbackLang('en');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // translate.use('en');
    this.setLang(localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en');
    this.auth.loggedIn.subscribe(val => {
      if (val) {
        this.processService.isAssigned().subscribe(res => {
          if (res.is_assigned){
            this.isAssigned = true;
          }
          this.loadData();
        })
        
      }
    });
    // Gated on a session, like the block above it. GET api/app_settings/modules
    // is behind auth/guard.js, so calling it anonymously returns 403
    // {message:'missing token'} -- which the interceptor turns into a red toast
    // over the login form. Harmless to the server, alarming to the user, and it
    // only became visible when local authentication put a real login page in
    // front of an anonymous visitor instead of an immediate SSO redirect.
    if (this.hasSession()) {
      this.loadModules();
    }
  }

  /** Which optional modules the top menu shows. Settled by the server. */
  private loadModules() {
    this.settings.modules$().subscribe(configuration => {
      this.controlsModuleEnabled = configuration?.modules?.controls ?? false;
    });
  }

  loadData() {
        this.userService.getCurrentUser().subscribe(user => {
          if (user !== null) {
            this.user = user;
            this.getServices();
            this.updateSidenavFromUrl(this.currentUrl);
          }
        });
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.updateSidenavFromUrl(this.currentUrl);

    /*
     * The header keeps its own copy of the user, for the avatar and the name in
     * the menu. The profile screen writes that user, so it announces the change
     * here -- otherwise the avatar keeps the old initials and colour until the
     * next full page load, and saving looks like it did nothing.
     */
    this.userChangedSubscription = this.sharedService.updateToken.subscribe(() => {
      this.loadData();
      // Also the module switches: the settings screen announces a save the same
      // way, and CERBERE would otherwise stay in the menu until the next full
      // page load, making the switch look like it did nothing.
      this.loadModules();
    });

    /*
     * The offered languages, from the admin settings screen. Failure is silent
     * on purpose: the switcher already holds the /app-config.json list, and a
     * settings request that does not come back should not take the language
     * switcher away with it.
     *
     * Gated on a session for the same reason as modules$() and the notification
     * count: GET api/app_settings is behind auth/guard.js, so calling it
     * anonymously answers 403 {message:'missing token'} -- which the
     * interceptor turns into a red toast over the login form. Harmless to the
     * server, alarming to the person trying to sign in, and this one was the
     * toast that survived: it was added after the other two were gated.
     */
    if (this.hasSession()) {
      this.settings.getAdminSettings().subscribe({
        next: (all) => {
          const record = Array.isArray(all) ? all[0] : all;
          if (record) this.applyConfiguredLanguages(record.languages);
          // The same record carries any help cards an administrator has
          // retitled, so the side menu on /help says what the page says.
          this.helpCards = mergeHelpCards(record?.[CARDS_KEY]);
          if (this.getMenuKeyFromUrl(this.currentUrl) === 'help') {
            this.setupMenu(this.buildHelpMenu());
          }
        },
        // The shipped cards are already loaded, so the menu is complete either
        // way -- only an administrator's retitling is missed.
        error: () => { /* keep the compiled/app-config list */ },
      });
    }
    this.leftMenuSubscription = this.sharedService.menuItemsEmitter.subscribe(menuItems => {
      this.setupMenu(menuItems);
    });
    this.router.events
      .subscribe(
        (event: NavigationEvent) => {
          if (event instanceof NavigationEnd) {
            this.currentUrl = event.urlAfterRedirects;
            this.updateSidenavFromUrl(event.urlAfterRedirects);
          }
          if (event instanceof NavigationStart) {
            this.closeMobileMenu();
          }
        });
    // this.userService.getCurrentUser().subscribe(user => {
    //   if (user!==null){
    //     this.user = user;
    //   this.getServices()
    //   }

    // })
    // Same reason as modules$() above: api/notification/unseen is guarded, so an
    // anonymous visitor on the login page got a 'missing token' toast, and then
    // another one every 60 seconds while the page sat open.
    if (this.hasSession()) {
      this.getUnseenNotifications();
      // Poll only while the tab is visible; an inactive tab makes no requests.
      this.unseenTimer = setInterval(() => {
        if (!document.hidden) { this.getUnseenNotifications(); }
      }, 60000);
    }
    // Returning to the tab refreshes immediately instead of waiting a tick.
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  ngOnDestroy() {
    if (this.userChangedSubscription) this.userChangedSubscription.unsubscribe();
    clearInterval(this.unseenTimer);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  private unseenTimer: any;
  private userChangedSubscription: any;

  /**
   * Which languages this deployment offers.
   *
   * Two sources, in order: the admin settings screen, and /app-config.json.
   * The file was the only source, which meant changing the offered languages
   * needed someone with access to the CDN bucket -- so it starts from the file
   * and is replaced once the settings arrive, rather than leaving the switcher
   * empty while the request is in flight.
   *
   * A field, not a getter: a getter would run on every change-detection pass.
   */
  languages: readonly string[] = languages();

  /**
   * English is never removed, whatever the settings say -- the server enforces
   * the same rule, for the same reason: it is the fallback every other bundle
   * degrades to, so a list without it renders missing keys as their own names.
   */
  private applyConfiguredLanguages(configured: unknown): void {
    if (!Array.isArray(configured)) return;

    // SUPPORTED_LANGUAGES, not a second hardcoded list: it is one entry per
    // file in assets/i18n, and a code without a file renders raw keys.
    const kept = (SUPPORTED_LANGUAGES as readonly string[]).filter(code =>
      code === 'en' ||
      configured.some(c => typeof c === 'string' && c.trim().toLowerCase() === code));

    this.languages = kept;
    // A language that is no longer offered must not stay selected, or the user
    // is left reading a bundle the deployment has withdrawn with no way back to
    // one it still offers.
    if (!kept.includes(this.lang)) this.setLang('en');
  }

  /**
   * The flag for a language code.
   *
   * Flags are a poor stand-in for languages in general -- Dutch is shown with
   * the Netherlands flag in a Surinamese deployment -- but it is the convention
   * already in this header, and `french.png` for French rather than Senegal's
   * flag is the same choice. Kept consistent rather than half-changed.
   */
  flagFor(code: string): string {
    const files: Record<string, string> = {
      en: 'assets/img/english.png',
      fr: 'assets/img/french.png',
      nl: 'assets/img/dutch.svg',
    };
    return files[code] || 'assets/img/english.png';
  }

  /** See util/session.util.ts for why this is not `auth.loggedIn`. */
  private hasSession(): boolean {
    return hasStoredSession(this.sharedService.getAccessToken());
  }
  private onVisibilityChange = () => {
    if (!document.hidden) { this.getUnseenNotifications(); }
  };

  getUnseenNotifications() {
    this.notificationService.getUnseenCount().subscribe(count => {
      this.unseenNotifications = count['count'];
    });
  }
  
  navigateToNotifications() {
    this.router.navigate(['notifications']);
  }
  navigateToNotification(value) {
    const route = value.referenceObject ? '/proposal/' + value.referenceObject.id + '/' + value.referenceObject.key : 'notifications';
    this.router.navigate([route]);
  }

  setSeenAll() {
    this.unseenNotifications = 0;

    this.notificationService.setSeenAll().subscribe(result => {
      this.notificationService.getNotificationList().subscribe(res => {
        this.dropDownNotifications = res;
       });
    });
  }

  getServices() {
    this.serviceService.getTotalServiceList('').subscribe(services => {
      this.services = services;
    });
  }

  logout() {
    this.username = '';
    this.auth.logout().subscribe(res => {
      this.router.navigate(['login']);
      this.auth.setLoginStatus(false);
    });
  }

  /*
   * Own profile, NOT the user-administration form.
   *
   * This used to open /user/:id -- the ADMIN screen that edits roles, status
   * and regional attachments -- so looking at your own account meant opening a
   * form most users are not allowed to submit.
   */
  userAccount() {
    this.router.navigate(['profile']);
  }

  reportIssue() {
    this.router.navigate(['issues']);
  }

  releaseNotes() {
    this.router.navigate(['release-notes']);
  }

  setupMenu(menuItems) {
    if (menuItems !== 'services') {
      this.leftMenuItems = menuItems;
    } else {
      this.serviceService.getTotalServiceList('').subscribe(services => {
        this.leftMenuItems = [];
        services.forEach(service => {
          this.leftMenuItems.push({ title: service.name, link: '/csv-list/' + service.id });
        });
      });
    }
  }

  setLang(lang) {
    this.sharedService.setLan(lang);
    this.lang = lang;
    this.translate.use(lang);
    // The help menu is card TITLES, not translation keys, so the pipe cannot
    // relabel it when the language changes -- it has to be rebuilt.
    if (this.currentUrl && this.getMenuKeyFromUrl(this.currentUrl.split('#')[0]) === 'help') {
      this.setupMenu(this.buildHelpMenu());
    }
  }

  /**
   * The help page's own contents, as the side menu.
   *
   * Every other section's menu is a fixed list of routes. Help has one route
   * and thirty cards on it, so the menu lists the cards and each entry is a
   * fragment link to one -- otherwise the rail beside a long page says "Help"
   * and nothing else, which is no use for finding anything.
   *
   * Built here rather than emitted by the help component because the header
   * rebuilds the menu on every NavigationEnd, which fires after the component
   * has initialised: anything the page pushed would be overwritten a moment
   * later.
   */
  private buildHelpMenu(): any[] {
    return this.helpCards.map(card => ({
      title: textFor(card.title, this.lang),
      link: '/help',
      fragment: card.id,
    }));
  }

  isMenuItemActive(menuItem: any): boolean {
    // A menu of fragment links all share one route, so the fragment is what
    // tells them apart.
    if (menuItem.fragment) {
      return this.currentUrl.split('#')[1] === menuItem.fragment;
    }
    const url = this.currentUrl.split('?')[0].split('#')[0];
    const matches = url === menuItem.link || url.startsWith(menuItem.link + '/');
    if (!matches) return false;
    return !this.leftMenuItems.some(other =>
      other !== menuItem &&
      other.link.startsWith(menuItem.link) &&
      (url === other.link || url.startsWith(other.link + '/'))
    );
  }

  private getMenuKeyFromUrl(rawUrl: string): string | null {
    // The help menu links to fragments on its own page, so every url reaching
    // here can carry one. Matching '/help#mfa' against '/help' would empty the
    // menu the moment somebody used it.
    const url = (rawUrl || '').split('#')[0];
    if (url.startsWith('/csv-list')) return 'services';
    if (url.startsWith('/company')) return 'company';
    if (url.startsWith('/home')) return 'home';
    if (url === '/indicator' || url.startsWith('/indicator/')) return 'indicator';
    if (url.startsWith('/report')) return 'report';
    if (url === '/help') return 'help';
    if (url === '/user' || url.startsWith('/user?')) return 'admin';
    if (url.startsWith('/user/')) return 'user-profile';
    // The avatar-menu pages. They share one side menu so that opening any of
    // them looks like every other section rather than like a page whose menu
    // failed to load -- and so the other two are reachable once you are there.
    if (url.startsWith('/profile') || url.startsWith('/release-notes') ||
        url.startsWith('/issues')) return 'account';
    // Every admin route needs a prefix here. Missing one makes this return
    // null, which empties the side menu on NavigationEnd and also leaves the
    // header's Admin dropdown unhighlighted (see isAdminRoute above). Note
    // '/portal-dashboard-group' does not start with '/dashboard', so it needs
    // its own entry.
    const adminPrefixes = ['/ext-api', '/service', '/batch-process',
      '/dashboard', '/portal-dashboard-group', '/currency', '/payee-sector',
      '/regional-officer', '/indicator-sectors', '/control-team', '/admin',
      '/help-editor', '/portal-content', '/portal-newsletter',
      // The invite screen is reached from the user list, not from the menu, so it
      // gets no menu ENTRY -- but it is an admin screen and must keep the admin
      // sidenav visible. Omitting the prefix here is the documented footgun: the
      // page renders with no left menu and looks broken.
      // The issue LIST deliberately has no entry here: it is reached from the
      // user menu by everyone, so it belongs to the 'account' menu above and
      // giving it the admin sidenav would be wrong.
      // The issue tracker SETTINGS are a tab on /admin, which is covered above.
      '/user-invite'];
    if (adminPrefixes.some(p => url.startsWith(p))) return 'admin';
    return null;
  }

  private updateSidenavFromUrl(url: string) {
    const key = this.getMenuKeyFromUrl(url);
    if (key === 'help') {
      // Not a fixed list in SharedService like the others: the entries are the
      // help cards themselves, and an administrator can retitle any of them.
      this.setupMenu(this.buildHelpMenu());
    } else if (key === 'user-profile') {
      if (this.user?.roles?.includes('ADMIN')) {
        this.setupMenu(this.sharedService.allMenuItems['admin'] || []);
      } else {
        this.setupMenu([{ title: 'PROFILE.MENU', link: '/profile' }]);
      }
    } else {
      this.setupMenu(key !== null ? (this.sharedService.allMenuItems[key] || []) : []);
    }
  }

  openControlModule() {
    window.open(window.location.origin + '/control-module');
  }

  private setScrollLock(locked: boolean) {
    const value = locked ? 'hidden' : '';
    document.body.style.overflow = value;
    document.documentElement.style.overflow = value;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    this.setScrollLock(this.mobileMenuOpen);
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
    this.sidenavOpen = false;
    this.servicesExpanded = false;
    this.adminExpanded = false;
    this.setScrollLock(false);
  }

  toggleSidenav() {
    this.sidenavOpen = !this.sidenavOpen;
    if (this.sidenavOpen) {
      this.mobileMenuOpen = false;
      this.servicesExpanded = false;
      this.adminExpanded = false;
    }
    this.setScrollLock(this.sidenavOpen);
  }

  closeSidenav() {
    this.sidenavOpen = false;
    this.setScrollLock(false);
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth >= 1200) {
      if (this.mobileMenuOpen || this.sidenavOpen) {
        this.closeMobileMenu();
      }
    }
  }

}
